import React, { Fragment } from 'react';
import { Link } from "react-router-dom";
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { InputField } from '../controls/Fields/InputField';
import { MapPopup } from '../controls/Mapping/MapPopup';
import { TableLink } from '../controls/Planning/TableLink';
import { Phone } from '../controls/ReactIcons/Phone';
import { LoginPanel } from '../controls/Security/LoginPanel';
import { ArcaComponent } from './ArcaComponent';
import { ArcaHttpClientSearch } from '../../code/ArcaHttpClientSearch';
import { ArcaRedirect } from '../../code/ArcaRedirect';

export class SearchDb extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            searchFieldValid: true,
            searchResults: null,
            mapPopupOpen: false,
            refresh: false
        };
    }

    render() {

        var key = 0;

        return (
            <div>
                <h1 className='centerText'>Search</h1>

                {!ArcaSecurity.IsLoggedIn
                    ? <LoginPanel onLogon={(() => this.setState({ refresh: true }))} />
                    : <Fragment>

                        <InputField
                            fieldname='Search ..'
                            regularExpression='free'
                            warnText='Invalid search text format'
                            mandatory={false}
                            showHeader={false}
                            onUpdate={this.getPeopleBySearch.bind(this)}
                            fieldValid={this.state.searchFieldValid} />

                        {this.state.searchResults === null
                            ? <div>Perform the search by typing names, address or pet names.</div>
                            :
                            <table className='table table-striped' aria-labelledby="tabelLabel">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Call</th>
                                        <th>Address Line</th>
                                        <th>Postcode</th>
                                        <th>Pet Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.searchResults.map(person =>
                                        <tr key={key++}>
                                            <td>
                                                <Link to={"/PersonView?id=" + person.Id}>{person.FirstName} {person.LastName}</Link>
                                            </td>
                                            <td>
                                                {(person.Mobile || person.Home)
                                                    ? <Phone phone={person.Mobile ?? person.Home} text='Call:' />
                                                    : null}
                                            </td>

                                            <td>{person.AddressLine1}</td>

                                            {person.Postcode && person.Postcode.length > 4
                                                ? <td>
                                                    <TableLink
                                                        text={person.Postcode}
                                                        onClick={((postcode, name) =>
                                                            this.setState({
                                                                postcode: postcode,
                                                                personName: name,
                                                                mapPopupOpen: true
                                                            })) } />
                                                           {/* .bind(this, person.Postcode, person.FirstName + ' ' + person.LastName)} />*/}
                                                </td>
                                                : <td>{person.Postcode}</td>}

                                            <td onClick={() => ArcaRedirect.Push("/PetEdit?id=" + person.PetId + '&personid=' + person.Id)}>

                                                {person.PetName}
                                                
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>}


                        {this.state.mapPopupOpen
                            ? <MapPopup
                                headerText={"Home of :" + this.state.personName}
                                postcode={this.state.postcode}
                                onClose={(() =>
                                    this.setState({ mapPopupOpen: false })) /*.bind(this)*/
                                } />
                            : null}

                    </Fragment>}
            </div>
        );
    }

    async getPeopleBySearch(searchString, valid) {

        if (valid && searchString.length < 3) {
            return;
        }

        ArcaHttpClientSearch.Search(
            searchString,
            (findings => this.setState({ searchResults : findings})),
            (msg => alert(msg))
        )
    }
}
